import { BubbleMenu } from '@tiptap/react';
import { TextStylesMenu } from './menu/text-styles-menu.component';
import { FormattingMenu } from './menu/text-format-menu.component';
import { ColorMenu } from './menu/color-menu.component';
import { ListingMenu } from './menu/listing-menu.component';
import styled from 'styled-components';
import { styleVariables } from '../../../style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledBubbleMenu = styled(BubbleMenu).withConfig({
  displayName: "menu-editor-bublecomponent__StyledBubbleMenu",
  componentId: "sc-1epkgz0-0"
})(["font-size:", ";background-color:", ";border-radius:", ";.ant-select,.ant-select-item-option-content{font-size:", ";}.ant-btn-icon-only{width:26px;}"], styleVariables.font.fontSizeSupport, function (props) {
  return props.theme.color.backgroundOverlay;
}, styleVariables.borderRadius.medium, styleVariables.font.fontSizeSupport);

var MenuEditorBubleComponent = function MenuEditorBubleComponent(_ref) {
  var editor = _ref.editor,
      labels = _ref.labels;

  if (!editor) {
    return null;
  }

  return /*#__PURE__*/_jsxs(StyledBubbleMenu, {
    className: "bubble-menu",
    tippyOptions: {
      duration: 100
    },
    editor: editor,
    children: [/*#__PURE__*/_jsx(TextStylesMenu, {
      editor: editor,
      labels: labels
    }), /*#__PURE__*/_jsx(FormattingMenu, {
      editor: editor,
      labels: labels
    }), /*#__PURE__*/_jsx(ColorMenu, {
      editor: editor,
      labels: labels
    }), /*#__PURE__*/_jsx(ListingMenu, {
      editor: editor,
      labels: labels
    })]
  });
};

export default MenuEditorBubleComponent;